
<template>
    <div @click="moveInOther" style="display:flex; height:64px; padding-top:3px; padding-bottom:7px; border-top: 1px solid #f5f5f5; background-color: white; position: relative">
        <div class="btn_wrap" @click="goPage('/view/home')">
            <div class="img_wrap"><img class="bottom_btns" :src="require('@/assets/home2_' + (pathName === '/view/home' ? 'on' : 'off') + '.png')" style="height:21px; width:21px;"></div>
        </div>
        <div class="btn_wrap" @click="goPage('/view/soccer_learn')">
            <div class="img_wrap"><img class="bottom_btns" :src="require('@/assets/soccer_learn_' + (pathName === '/view/soccer_learn' || pathName === '/training_main' ? 'on' : 'off') + '.png')"></div>
        </div>
        <div class="btn_wrap" @click="goPage('/view/soccer_join')">
            <div class="img_wrap"><img class="bottom_btns" :src="require('@/assets/soccer_join_' + (pathName === '/view/soccer_join' || pathName === '/soccer_join' || pathName === '/view/mercenary' ? 'on' : 'off') + '.png')"></div>
        </div>
        <div class="btn_wrap" @click="goPage('/view/mychat')">
            <div class="img_wrap"><img class="bottom_btns" :src="require('@/assets/chat_' + (pathName === '/view/mychat' ? 'on' : 'off') + '.png')"></div>
        </div>
        <div class="btn_wrap" @click="goPage('/view/my')" style="">
            <div class="img_wrap">
                <ProfileImage style="width: 30px" :style="{border: pathName === '/view/my' ? '2px solid #210f03' : '2px solid #d9d9d9'}" :imagePath="myImagePath"></ProfileImage>
                <!-- <img class="bottom_btns" :src="require('@/assets/my_' + (pathName === '/view/my' ? 'on' : 'off') + '.png')" style="height:24px;"> -->
            </div>
        </div>
        <div v-if="$GlobalStore.loginInfo() ? $GlobalStore.loginInfo().is_temp_coach == 0 && pathName !== '/view/home' && isShowMakeFeed : false" @click="showMakeFeed" class="plus_btn">
            <img style="width: 28px;" :src="require('@/assets/img/plus_orange.png')" alt="">
        </div>
    </div>
</template>

<script>
import ProfileImage from '@/components/common/ProfileImage'
import { VISIT_REASON_TYPE } from '@/Constants'
import moment from 'moment';

export default {
    name: "PageBottom",
    components: { ProfileImage },
    props: {
        moveInOther: {
            type: Function,
            default: () => { }
        },
        goTopScroll: {
            type: Function,
            default: () => { }
        },
        completeAction: {
            type: Function,
            default: () => {}
        },
        trainingBannerList: {
            type: Array,
            default: () => []
        },
        isShowMakeFeed: {
            type: Boolean,
            default: true
        },
        showConfirmSoccerhowDraft: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            pathName: '',
            actionWhenWebSelected: null,
            VISIT_REASON_TYPE: VISIT_REASON_TYPE,
        }
    },
    mounted() {
        this.pathName = location.pathname;
    },
    computed: {
        myImagePath() {
            if (this.$GlobalStore.loginInfo()) {
                return this.$GlobalStore.loginInfo().image_path
            } else {
                return null
            }
        }
    },
    methods: {
        goPage(page) {
            this.$GlobalStore.setIsShowAppLinkToast(false);

            if (page === location.pathname) {
                this.goTopScroll()
                return
            }
            if (page === '/view/my') {
                if (!this.$Util.checkLoginAndWeb()) {
                    return
                }

                const [is_default_complete] = this.$Util.checkDefaultMemberInfoComplete();

                if (!is_default_complete) {
                    this.$GlobalStore.showAlert('기본정보 입력 후 확인가능합니다.');
                    this.$GlobalStore.showRequiredMemberInfoSetting(0);
                    return;
                }
            }

            if (page === '/view/home') {
                this.$Util.sendEventClick('하단_탭_홈', true)
            } else if (page === '/view/soccer_learn') {
                this.$Util.sendEventClick('하단_탭_축구배우기', true)
            } else if (page === '/view/soccer_join') {
                this.$Util.sendEventClick('하단_탭_축구팀입단', true)
            } else if (page === '/view/mychat') {
                this.$Util.sendEventClick('하단_탭_멤버톡', true)
            } else if (page === '/view/my') {
                this.$Util.sendEventClick('하단_탭_마이페이지', true)
            }

            this.$router.push({ path: page + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
            this.pathName = page;
        },
        goWriteGroundPost() {
            this.$GlobalStore.addModal('WriteGroundPost', {
                completeAction: this.completeAction,
                trainingBannerList: this.trainingBannerList
            })
        },
        async showMakeFeed() {
            if (this.pathName === '/view/soccer_join') {
                const res = await this.$Axios.get('/api/soccerhow/get/draft')
                if (res.data.soccerhow_draft) {
                    this.showConfirmSoccerhowDraft(res.data.soccerhow_draft)
                } else {
                    this.$GlobalStore.addModal('MakeFeedSoccerJoin', {
                        isModalBackTransparent: true,
                        completeAction: this.completeAction,
                        transitionName: 'bottom',
                        isHaveSwiper: true,
                        trainingBannerList: this.trainingBannerList
                    })
                }

            } else {
                if (this.$GlobalStore.getVisitReasonType() === VISIT_REASON_TYPE.LEARN_SOCCER) {
                    const isHide = localStorage.getItem('HIDE_SEVEN_DAYS');
                    if (isHide) {
                        const hideSevenDays = moment(isHide);
                        const now = moment();
                        if (hideSevenDays.isAfter(now)) {
                            this.goWriteGroundPost()
                            return
                        }
                    }
                    this.$GlobalStore.addModal('EventPopup', { isModalBackTransparent: true, transitionName: '', event_type: 'write', showWriteForm: () => {
                        this.goWriteGroundPost()
                    } })
                    return
                }
                this.goWriteGroundPost()
                // this.$GlobalStore.addModal('MakeFeed', {
                //     isModalBackTransparent: true,
                //     completeAction: this.completeAction,
                //     transitionName: 'bottom',
                //     isHaveSwiper: true,
                //     trainingBannerList: this.trainingBannerList
                // })

            }
        }
    }
}
</script>

<style scoped>
.plus_btn {
    position: absolute; 
    z-index: 20;
    top: -75px;
    right: 15px;
    width: 60px; 
    height: 60px; 
    background-color: #fff; 
    box-shadow: 0px 4px 36px 0px #210F0314; 
    /* backdrop-filter: blur(5px);  */
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #FFFFFFCC
}
.btn_wrap {
    flex: 1;
    height: 56px;
    text-align: center;
    padding: 12px 5px;
    display: flex;
    flex-direction: column;
}

.img_wrap {
    flex: 1;
    display: grid;
    place-items: center;
}

.bottom_btns {
    height: 21px;
}
</style>
